import { gql } from '@apollo/client';

import { materialsFragment } from 'approot/shared/graphql/lesson/lesson.graphql';
import { OutcomesFragment } from 'approot/shared/graphql/outcomes/outcomes.graphql';

export const lessonTeachingLearningSequenceFragment = gql`
  fragment LessonTeachingLearningSequenceFragment on Lesson {
    id
    materials {
      ...MaterialsFragment
    }
    teachingAndLearningSequence {
      id
      category
      type
      data {
        span
        differentiation
        checkPoint
        furtherEnrichment
        duration
        richtext
      }
      questionGroupId
      sort
      theEsDetails {
        id
        name
        link
      }
      connections {
        subject
        outcomes {
          ...OutcomesFragment
          description
          type
        }
      }
    }
  }
  ${materialsFragment}
  ${OutcomesFragment}
`;

export const UPDATE_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation UpsertStaticTeachingLearningSequenceLessonItem(
    $input: UpsertStaticTeachingLearningSequenceItemInput!
  ) {
    upsertStaticTeachingLearningSequenceLessonItem(input: $input) {
      ...LessonTeachingLearningSequenceFragment
    }
  }
  ${lessonTeachingLearningSequenceFragment}
`;

export const DELETE_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation DeleteStaticTeachingLearningSequenceLessonItem(
    $input: DeleteStaticTeachingLearningSequenceItemInput!
  ) {
    deleteStaticTeachingLearningSequenceLessonItem(input: $input) {
      ...LessonTeachingLearningSequenceFragment
    }
  }
  ${lessonTeachingLearningSequenceFragment}
`;
